module.exports = __webpack_public_path__ + "img/pic_01_nor.7283fde3.png";